import React, { useContext, useEffect, useState } from 'react'

import AboutSection from '../components/Public/Home/AboutSection'
import AppSection from '../components/Public/Home/AppSection'
import EditHomeDetails from '../components/Public/Home/EditHomeDetails'
import FeaturesSection from '../components/Public/Home/FeaturesSection'
import HomeDetails from '../components/Public/Home/HomeDetails'
import AddDetail from '../components/Public/Home/Templates/AddDetail'
import ImageWrap from '../components/Public/Media/ImageWrap'
import Hero from '../components/View/Hero'
import Parallax from '../components/View/Parallax'
import { firestore } from '../firebase'
import StateContext from '../StateContext'

function HomePage() {

    const appState = useContext(StateContext)

    const [show, setShow] = useState(false);
    const [features, setFeatures] = useState([]);

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    useEffect(() => {

        try {
            const featuresRef = firestore.collection("site_details").doc("X0LJ5z6LWL0qF8AluQLA").collection("home_cards");
            featuresRef.where("type", "==", "featured").onSnapshot(({docs}) => {
                const features = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setFeatures(features);
            })
        } catch (error) {
            
        }

    }, [])


    return (
        <>

            <Hero />

            {features?.map((feature, index) => {
                return (
                    <AboutSection
                        key={index}
                        title={feature.title} 
                        link={feature.link}
                        description={feature.description}
                        image={feature.image}
                        lastChild={index+1 === features.length}
                    />
                )
            })}

            <FeaturesSection />
            
            <div className="container my-3">
                <HomeDetails />
            </div>

            <Parallax />
            <div className="container py-5">
                <AppSection />
                {appState.loggedIn && appState.isAdmin && (
                    <React.Fragment>
                        <button className="btn" onClick={toggle}><i className={`${!show ? "fas fa-edit" : "fas fa-window-close"}`}></i></button>
                        {show && (
                            <React.Fragment>
                                <div className="container">
                                    <AddDetail />
                                </div>
                                <EditHomeDetails />
                            </React.Fragment>
                        )}
                    </React.Fragment>
                    
                )}
            </div>
            <ImageWrap />

        </>
    )
}
export default HomePage